import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentPerformance = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentPerformance' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M3,19 L8,14 L12,18 L18.5,11.5 M19,17.0003099 L19,11 L13,11' />
  </StyledIcon>
);
